module.exports = __webpack_public_path__ + "static/media/drgn.472972ed.svg";